import Logger from '@/logger'

import Store from '@/store'

import AddressService from './address-service'
import AuthService from './auth-service'
import CaptchaService from './captcha-service'
import ContactService from './contact-service'
import ImprovementService from './improvement-service'
import ProfileService from './profile-service'
import SavingService from './saving-service'
import RenovationService from './renovation-service'
import SchemeService from './scheme-service'
import ServiceBasketService from './service-basket-service'
import StatusService from './status-service'
import TestService from './test-service'

/* A Cache variable to hold instantiated services. */
const serviceCache = {}

const getAndCacheService = function(serviceName, InstanceType, params) {
    if (!serviceCache[serviceName]) {
        serviceCache[serviceName] = params ? new InstanceType(params) : new InstanceType()
        Logger.logObject(serviceCache, 'Service cache updated', 'Services')
    }
    return serviceCache[serviceName]
}

/**
 * Provides required service implementations.
 * This class is designed to provide the required service classes when requested.
 */
export default {

    /**
     * Builds a service or retrieves it from cache.
     * @returns {AddressService}
     */
    address() {
        return getAndCacheService('address', AddressService, { schemeId: Store.state.scheme.id })
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {AuthService}
     */
    auth() {
        return getAndCacheService('auth', AuthService, { schemeId: Store.state.scheme.id })
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {CaptchaService}
     */
    captcha() {
        return getAndCacheService('captcha', CaptchaService)
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {ContactService}
     */
    contact() {
        return getAndCacheService('contact', ContactService)
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {ImprovementService}
     */
    improvement() {
        return getAndCacheService('improvement', ImprovementService, { schemeId: Store.state.scheme.id })
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {ProfileService}
     */
    profile() {
        return getAndCacheService('profile', ProfileService, { schemeId: Store.state.scheme.id })
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {RenovationService}
     */
    renovation() {
        return getAndCacheService('renovation', RenovationService, { schemeId: Store.state.scheme.id })
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {SavingService}
     */
    saving() {
        return getAndCacheService('saving', SavingService, { schemeId: Store.state.scheme.id })
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {SchemeService}
     */
    scheme() {
        return getAndCacheService('scheme', SchemeService, { schemeId: Store.state.scheme.id })
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {ServiceBasketService}
     */
    basket() {
        return getAndCacheService('basket', ServiceBasketService)
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {StatusService}
     */
    status() {
        return getAndCacheService('status', StatusService)
    },

    /**
     * Builds a service or retrieves it from cache.
     * @returns {TestService}
     */
    test() {
        return getAndCacheService('test', TestService)
    },
}
